import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { retry } from 'rxjs/operator/retry';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class UtilitiesService {

  private serviceName = 'api/home'
  constructor(private http: Http, private readonly router: Router,
    private cookieService: CookieService)
  {
  }

  
  intializeHome() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //generic search function from whole array object passing to it
  GetSearchedResult(dataArray: any[], searchText: string): any[] {
    return dataArray.filter(item =>
      Object.keys(item).some(k => item[k] != null &&
        item[k].toString().toLowerCase()
          .includes(searchText.trim().toLowerCase())));
  }

  GetRowsPerPageList(): number[] {
    let arrRows = [10, 25, 50,100];
    return arrRows;
  }

  formatDate(date: any) {
    var v = new Date(date);
    var day = v.getDate();
    var monthIndex = v.getMonth();
    var year = v.getFullYear();
    return year + "-" + (monthIndex + 1) + "-" + day;
  }
  toggleButtonAnimation(btn: any) {
    if (btn.firstElementChild.hidden) {
      btn.disabled = false;
      btn.firstElementChild.hidden = false;
      btn.lastElementChild.hidden = true;

    }
    else {
      btn.disabled = true;
      btn.firstElementChild.hidden = true;
      btn.lastElementChild.hidden = false;

    }
  }
  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
         
            body{font-family:Arial!important}
            .checkoutProductImage{width: 55px !important;height: auto !important;margin: 8px !important;vertical-align: middle;}
            a{text-decoration:none!important;}
   
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared/utilities.service.ts